import { combineReducers } from 'redux';
import appReducer from './appReducer';
import userlistReducer from './userlistReducer';
import homeReducer from './homeReducer';
import parameterReducer from './parameterReducer';
import apiReducer from './apiReducer';
import clientRd from './clientRd';
import clientPendingRd from './clientPendingRd';
import orderRd from './orderRd';
import orderPendingRd from './orderPendingRd';
import clientCreditRd from "./clientCreditRd";
import repayFailRd from './repayFailRd';
import roleAuthRd from './roleAuthRd';
import purOrderPendingRd from './purOrderPendingRd';
import purOrderRd from './purOrderRd';
import purRecordOrderPendingRd from "./purRecordOrderPendingRd";
import clientRecommendRd from "./clientRecommendRd";
import purRecordOrderRd from "./purRecordOrderRd";
import orderClientQuotaRd from "./orderClientQuotaRd";
import purLoanAfterRd from "./purLoanAfterRd";
import purLoanPatchRd from "./purLoanPatchRd";
import briefReducer from "./briefReducer";
import antdCompTestReducer from "./antdCompTestReducer";
import clientLegalPersonRd from "./clientLegalPersonRd";
import orderExceedThirtyRd from "./orderExceedThirtyRd.js";
import orderExceedSixtyRd from "./orderExceedSixtyRd.js";
import noUsed30Rd from "./noUsed30Rd.js"
import projectAmount from "./projectAmount.js"
import monitorExceptionRd from "./monitorExceptionRd";
import monitorExceptionOrderRd from './monitorExceptionOrderRd';
import monitorExceptionOrderRepayRd from "./monitorExceptionOrderRepayRd";
import monitorEngExceptionRd from "./monitorEngExceptionRd";
import monitorEngExceptionOrderRd from './monitorEngExceptionOrderRd';
import monitorEngExceptionOrderRepayRd from "./monitorEngExceptionOrderRepayRd";
import controlProductOrderRd from "./controlProductOrderRd";
import derClientRecommendRd from "./derClientRecommendRd";
import derOrderRd from "./derOrderRd";
import derOrderPendingRd from "./derOrderPendingRd";
import derClientRd from "./derClientRd";
import derWareHouseOutRd from "./derWareHouseOutRd";
import derWareHouseConfirmRd from "./derWareHouseConfirmRd";
import derWareHouseInRd from "./derWareHouseInRd";
import derLoanAfterRd from "./derLoanAfterRd";
import orderDerClientQuotaRd from "./orderDerClientQuotaRd";
import clientRecommendSelfRd from "./clientRecommendSelfRd";
import monitorHistoryExceptionOrderRd from "./monitorHistoryExceptionOrderRd";

const allReducers = {
  antdCompTestReducer,briefReducer,  purLoanPatchRd,purLoanAfterRd,orderClientQuotaRd,clientRecommendRd,purRecordOrderRd,purRecordOrderPendingRd,userlistReducer,appReducer,homeReducer,parameterReducer,apiReducer,clientRd,clientPendingRd,orderRd,orderPendingRd,roleAuthRd,purOrderPendingRd,purOrderRd,clientLegalPersonRd,clientCreditRd,monitorExceptionRd,repayFailRd,orderExceedThirtyRd, orderExceedSixtyRd,noUsed30Rd,projectAmount,
  monitorEngExceptionRd,
  monitorEngExceptionOrderRd,
  monitorEngExceptionOrderRepayRd,
  monitorExceptionOrderRd,
  monitorExceptionOrderRepayRd,
  derWareHouseInRd,
  derWareHouseConfirmRd,
  derLoanAfterRd,
  controlProductOrderRd,derClientRecommendRd,derOrderRd,derOrderPendingRd,derClientRd,derWareHouseOutRd,orderDerClientQuotaRd,clientRecommendSelfRd,monitorHistoryExceptionOrderRd

}

const rootReducer = combineReducers(allReducers);

export default rootReducer;
